import React, { FC, useState } from 'react';
import Library from 'FeatureModules/Media/Components/Library';
import UploadDropZone from 'FeatureModules/Media/Components/UploadDropZone';
import { Dialog, DialogContent, DialogTitle, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import usePageTitle from 'hooks/usePageTitle';
import useUploadState from 'FeatureModules/Document/hooks/useUploadState';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import { SelectableProvider } from 'FeatureModules/Media/Contexts/SelectableContext';
import PageTitle from 'Components/PageTitle';
import PageContainer from 'Components/PageContainer';

const UploadContainer = styled('div')({
  width: 850,
});

const ButtonWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100',
  marginTop: theme.spacing(2),
}));

const MediaLibrary: FC = () => {
  usePageTitle('Media');
  const [isUploadActive, setIsUploadActive] = useState(false);
  const { undoFileUploads } = useUploadState();

  return (
    <PageContainer>
      <PageTitle title="Media" />

      <Box className="scrollwrapper">
        <SelectableProvider setUploadActive={() => setIsUploadActive(true)}>
          <Library windowScroll={true} withUploadModal={true} />
        </SelectableProvider>
      </Box>

      <Dialog
        open={isUploadActive}
        onClose={() => {
          setIsUploadActive(false);
        }}
        maxWidth="lg"
        aria-labelledby="form-dialog-title"
        data-testid="dialog-upload-media-library"
      >
        <DialogTitle id="form-dialog-title">Upload Media</DialogTitle>
        <DialogContent>
          <UploadContainer>
            <UploadDropZone />

            <ButtonWrapper>
              <ThemeButton
                onClick={() => {
                  undoFileUploads();
                  setIsUploadActive(false);
                }}
                color="BLUE_ICE"
                size="medium"
              >
                Cancel
              </ThemeButton>
              <ThemeButton
                onClick={() => setIsUploadActive(false)}
                color="PRIMARY"
                size="medium"
                data-testid="upload-dialog-save-button"
              >
                Save
              </ThemeButton>
            </ButtonWrapper>
          </UploadContainer>
        </DialogContent>
      </Dialog>
    </PageContainer>
  );
};

export default MediaLibrary;
